class ApEvents {
    events = {};
    /**
     * @method 挂接事件
     * @param {any} name 事件名称
     * @param {any} fn 事件回调函数
     */
    on(name, fn) {
        if (!fn || typeof (fn) !== 'function') {
            console.log('fn is not function');
        }
        if (!this.events[name])
            this.events[name] = [];
        if (this.events[name].length === 0) {
            this.events[name].push(fn);
        }
    }
    /**
     *@method  移除事件
     * @param {any} name 事件名称
     * @param {any} fn 要移除的函数，如果值为空，移除所有的事件
     */
    remove(name, fn) {
        if (!this.events[name])
            return;
        const index = this.events[name].findIndex(p => { return p === fn; });
        this.events[name].splice(index, 1);
        if (!this.events[name].length)
            delete this.events[name];
    }
    /**
     * 触发事件
     * @param {any} name 事件名称
     */
    emit(name, ...params) {
        if (!this.events[name])
            return;
        for (let index = 0; index < this.events[name].length; index++) {
            const fn = this.events[name][index];
            fn.apply(this, params);
        }
    }
}
const ApEvent = new ApEvents();
window.ApEvent = ApEvent;
export default ApEvent;
